import { useState } from 'react'
import { auroraStore, useAuroraStore } from '../store/auroraStore'
import { artifactKinds, artifacts } from '../store/selectors'
import { formatRelative } from '../lib/dates'

/**
 * Library — everything the agent and the family have made.
 *
 * The filter chips are built from the kinds actually present, not a fixed list,
 * so a kind the agent invented last week appears here automatically.
 */
export function LibraryView() {
  const all = useAuroraStore(artifacts)
  const kinds = useAuroraStore(artifactKinds)
  const [kind, setKind] = useState<string | null>(null)

  const shown = kind ? all.filter((a: any) => a.kind === kind) : all

  const open = (a: any) => {
    const s = auroraStore.getState() as any
    if (a.kind === 'activity') s.enterKidMode(a._id)
    else s.selectArtifact(a._id)
  }

  return (
    <div className="page">
      <header className="page-head">
        <div className="page-eyebrow">Library</div>
        <h1 className="page-title">Everything we've made</h1>
      </header>

      {kinds.length > 0 && (
        <div className="chips">
          <button
            className={`chip${kind === null ? ' is-active' : ''}`}
            onClick={() => setKind(null)}
          >
            All <span className="chip-count tnum">{all.length}</span>
          </button>
          {kinds.map(({ kind: k, count }) => (
            <button
              key={k}
              className={`chip${kind === k ? ' is-active' : ''}`}
              onClick={() => setKind(k)}
            >
              {k} <span className="chip-count tnum">{count}</span>
            </button>
          ))}
        </div>
      )}

      {shown.length === 0 ? (
        <div className="empty section">
          <p className="empty-title">Nothing here yet</p>
          <p className="empty-body">
            Ask Aurora to make something — a plan, an activity, a guide — and it will land here.
          </p>
        </div>
      ) : (
        <section className="section">
          <div className="lib-grid">
            {shown.map((a: any, i: number) => (
              <button
                key={a._id}
                className="lib-item reveal"
                style={{ '--i': i } as React.CSSProperties}
                onClick={() => open(a)}
              >
                <span className="lib-item-kind">{a.kind}</span>
                <span className="lib-item-title">{a.title}</span>
                {a.summary && <span className="lib-item-summary">{a.summary}</span>}
                <span className="lib-item-meta">
                  {formatRelative(a.updatedAt ?? a.createdAt)}
                  {a.version > 1 ? ` · v${a.version}` : ''}
                </span>
              </button>
            ))}
          </div>
        </section>
      )}
    </div>
  )
}
